import MainView from 'js/views/main';

export default class View extends MainView {
  constructor() {
    super();
  }

  mount(): void {
    super.mount();


    this.trackClick(
      '[data-action="register-user-novena"]', 
      'Clicked to register on user novena page'
    );
  }

  unmount(): void {
    super.unmount();
  }

  trackClick(selector: string, message: string): void {
    const button = document.querySelector(selector) as HTMLButtonElement | null;
    if (!button) { return; }
    button.onclick = () => this.track(message);
  }
}
